module.exports = __webpack_public_path__ + "media/silent-night_john-abbot.3e41d5f2.mp3";